import ExplorePage from './ExplorePage';

export default ExplorePage;
